/* eslint-disable no-console */
import {
  collection,
  doc,
  getDocs,
  getDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  onSnapshot
} from 'firebase/firestore';
import { useFirebaseStore } from '@/stores/firebase'
import { useSenhaStore } from '@/stores/senha'

// const collectionName = location?.host !== "etotem.com.br"
//   ? 'senha_totem' : 'senha_totem'

let collectionName;

export function realTimeSenha(id) {
  collectionName = location?.host !== "etotem.com.br"
    ? 'senha_totem' : 'senha_totem'

  console.log(collectionName == 'senha_totem' ? 'AMBIENTE PROD' : 'AMBIENTE DEV');

  closeRealTimeSenha()

  const firebaseStore = useFirebaseStore()
  const senhaStore = useSenhaStore()

  const docRef = doc(firebaseStore.db, collectionName, id);

  firebaseStore.rtSenha = onSnapshot(docRef, (snapshot) => {
    if (snapshot.data()?.id) {
      senhaStore.senha = { ...snapshot.data() }

      if (collectionName === 'dev_senha_totem') {
        console.log('senhaStore.senha', senhaStore.senha);
      }
    }
  })
}

export function closeRealTimeSenha() {
  const firebaseStore = useFirebaseStore()
  if (!firebaseStore.rtSenha) return

  const senhaStore = useSenhaStore()

  senhaStore.senha = {}
  firebaseStore.rtSenha()
}

export async function createSenha(senha) {
  collectionName = location?.host !== "etotem.com.br"
    ? 'senha_totem' : 'senha_totem'

  const firebaseStore = useFirebaseStore()
  const docRef = doc(firebaseStore.db, collectionName, senha.id);
  return await setDoc(docRef, senha)
}

export async function getSenhas() {
  collectionName = location?.host !== "etotem.com.br"
    ? 'senha_totem' : 'senha_totem'

  const firebaseStore = useFirebaseStore()
  const colRef = collection(firebaseStore.db, collectionName);
  const snapshot = await getDocs(colRef);
  return snapshot.docs.map((doc) => doc.data());
}

export async function getSenha(id) {
  collectionName = location?.host !== "etotem.com.br"
    ? 'senha_totem' : 'senha_totem'

  const firebaseStore = useFirebaseStore()
  const docRef = doc(firebaseStore.db, collectionName, id);
  const snapshot = await getDoc(docRef);
  return snapshot.data()
}

export async function updateSenha(senha) {
  collectionName = location?.host !== "etotem.com.br"
    ? 'senha_totem' : 'senha_totem'

  const firebaseStore = useFirebaseStore()
  const docRef = doc(firebaseStore.db, collectionName, senha.id);
  await updateDoc(docRef, senha)
}

export async function deleteSenha(id) {
  collectionName = location?.host !== "etotem.com.br"
    ? 'senha_totem' : 'senha_totem'

  const firebaseStore = useFirebaseStore()
  const docRef = doc(firebaseStore.db, collectionName, id);
  await deleteDoc(docRef);
}
/* eslint-enable no-console */
